<template>
    <div class="page bg-blue relative desktop-footer">
        <div class="bg-head-coin sm:block"></div>
        <div class="page-content mb-2 sm:px-8 pb-4">
            <TopBar class="hidden sm:block" title="Home" :isShowOnlyLogo="true" :isShowBack="true" :modalController="modalController"></TopBar>
            <TopbarBackLang routeBack="/" class="block sm:hidden"></TopbarBackLang>
            <MenuDesktop activeMenu=""></MenuDesktop>
            <div class="bg-white px-5 py-6 mt-10 mx-2 rounded-25">
                <div class="height-contents mb-5">
                    <ContentTermAndCondition ref="termandcondition" :modalController="modalController" />
                </div>
                <div class="hidden sm:block w-590px text-20 mx-auto" v-if="!isReadonly">
                    <div class="grid grid-cols-2 gap-4">
                        <div class="w-full">
                            <OutlineBlueBtn @click="onClickUnAccept()">{{lbl.terms.not_accept}}</OutlineBlueBtn>
                        </div>
                        <div class="w-full">
                            <BlueBtn @onClick="onClickAccept()">{{lbl.terms.accept}}</BlueBtn>
                        </div>
                    </div>
                </div>
            </div>
            <div class="sm:hidden pl-2" v-if="!isReadonly">
                <div class="bg-white width-btn-confirm fixed bottom-0 rounded-b-25">
                    <div class="grid grid-cols-2 gap-4 mt-5">
                        <div class="ml-4">
                            <OutlineBlueBtn @click="onClickUnAccept()">{{lbl.terms.not_accept}}</OutlineBlueBtn>
                        </div>
                        <div class="mr-4">
                            <BlueBtn @onClick="onClickAccept()">{{lbl.terms.accept}}</BlueBtn>
                        </div>
                    </div>
                    <div class="w-full p-4">
                        <div class="flex justify-center mt-5">
                            <img class="w-40" src="@/assets/poer-tip.png">
                        </div>
                    </div>
            </div>
            </div>
        </div>
        <BottomBar></BottomBar>
        <ModalMaster :controller="modalController"></ModalMaster>
    </div>
</template>

<script>
import MenuDesktop from "@/components/Layout/MenuDesktop/MenuDesktop.vue";
import TopBar from '@/components/Layout/TopBar/TopBar.vue';
import TopbarBackLang from '@/components/Layout/TopBar/TopbarBackLang.vue';
import BottomBar from '@/components/Layout/BottomBar/BottomBar.vue';
import ContentTermAndCondition from '@/module/TermAndConditions/component/Consent.vue';
import BlueBtn from "@/components/Button/BlueBtn.vue";
import OutlineBlueBtn from '@/components/Button/OutlineBlueBtn.vue';
import CacheHelper from '@/helper/CacheHelper'
//minxin
import ModalMixin from '@/mixin/ModalMixin';
import LocationHelper from '@/helper/LocationHelper';
import LocaleMixin from '@/mixin/LocaleMixin';

export default {
    name: 'TermAndCondition',
    components:{
        TopBar,
        TopbarBackLang,
        BottomBar,
        MenuDesktop,
        ContentTermAndCondition,
        BlueBtn,
        OutlineBlueBtn
    },
    mixins:[ModalMixin, LocaleMixin],
    data: function(){
        return{
            currentLat: 13.7248934,
            currentLng: 100.4926816,
        }
    },
     mounted: async function(){
        console.log(this.$route)
        this.modalController.loadingModal.show();
        await this.$refs['termandcondition'].apiGetUserConsent();
        this.modalController.loadingModal.hide();
        await this.getCurrentLocation();
    },
    computed:{
        isReadonly: function(){
            if(this.$route.query && this.$route.query.type === 'readonly'){
               return true
            }
            return false
        }
    },
    created: function(){
        this.setRefcodeFromGetFriend();
    },
    methods:{
        getCurrentLocation: function() {
            return new Promise((resolve) => {
                LocationHelper.getCurrentLocation().then((location) => {
                    this.currentLat = location.lat;
                    this.currentLng = location.lng;
                    resolve();
                }).catch((err) => {
                    console.log(err);
                    console.log(location);
                    // 13.7248934,100.4926816 bangkok
                    this.currentLat = 13.7248934;
                    this.currentLng = 100.4926816;
                    resolve();
                });
            });
        },
        setCacheLatLng: function() {
            let cache = new CacheHelper('session');
            let data = {
                latitude: this.currentLat,
                longitude: this.currentLng
            }
            cache.setCache('info', data);
        },
        setRefcodeFromGetFriend: function(){
            if(this.$route.params && this.$route.params.refcode){
                let cache = new CacheHelper('local');
                cache.setCache('refcode',this.$route.params.refcode);
                console.log(this.$route.params.refcode)
            }

        },
        onClickUnAccept: function(){
            this.$router.push('/')
        },
         onClickAccept: function(){
            this.$router.push('/verifypage')
        },
    }
};
</script>

<style lang="scss" scoped>
@import "@/style/base/base.scss";
.logo-mobile-size {
    width: 80px; //53px
}
@include mobile {
    .height-contents {
        min-height: 70vh
    }
}
.width-btn-confirm {
    width: calc(100% - 16px)
}
</style>
